import { Flex, styled } from '@shared/components';

const LocationSectionWrapper = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(4),
  padding: theme.spacing(4, 6),
}));

export default LocationSectionWrapper;
